import { portalCustomerApiSlice } from "./portalCustomerApiSlice";

export const portalCatalogueApiSlice = portalCustomerApiSlice.injectEndpoints({
  endpoints: builder => ({
    // Paginated customer catalogue with filters
    getPortalCustomerCatalogue: builder.query({
      query: params => ({
        url: "/api/portal/v1/customer_catalogue/",
        params, // { limit, offset, search, portal_category_ids, ordering, brand__icontains, brands }
      }),
      providesTags: ["PortalCatalogue"],
    }),

    // Portal buyer categories tree (buyer/flat tree)
    getPortalBuyerCategories: builder.query({
      query: () => "/api/portal/v1/categories/",
    }),
  }),
});

export const { useGetPortalCustomerCatalogueQuery, useGetPortalBuyerCategoriesQuery } =
  portalCatalogueApiSlice;
